export default __webpack_public_path__ + "static/media/ic_ppusd_24.6757bcef.svg";